<script lang="ts">
  import Router from 'svelte-app-router'
  import Event from './pages/Event.svelte'
  import type { SvelteComponent } from 'svelte'

  const routes: Record<string, (typeof SvelteComponent)[]> = {
    '/': [Event],
    '/event': [Event],
  }
</script>

<style lang="scss">
  :global(.svelte-app-router) {
    display: block;
    max-height: unset;
  }
</style>

<Router {routes} />
